import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EmailInputComponent } from '../../../../../ui/form-components/email-input/email-input/email-input.component';

@Component({
  selector: 'app-member-table-email-input',
  templateUrl: '../../../../../ui/form-components/email-input/email-input/email-input.component.html',
  styleUrls: ['../member-table-input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MemberTableEmailInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MemberTableEmailInputComponent extends EmailInputComponent {}
